import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ButtonPrimitive } from '../button-primitive/button-primitive.js';

/**
 * A button that hides or shows an expandable popup
 * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded
 * @see https://fpl.figma.design/primitives/popup-button/
 */
const PopupButtonPrimitive = forwardRef(({ 'aria-expanded': ariaExpanded, ...props }, ref) => {
    // Coerce missing/undefined (e.g. from object spreads) to false so the attribute stays set.
    return (jsx(ButtonPrimitive, { ref: ref, ...props, "aria-expanded": ariaExpanded ?? false, type: "button" }));
});
PopupButtonPrimitive.displayName = 'PopupButtonPrimitive';

export { PopupButtonPrimitive };
//# sourceMappingURL=popup-button-primitive.js.map
